<div class="form-group input-group form-floating mt-4-plus mt-md-5 d-flex">
  <input type="text"
         #currencyInput
         class="form-control currency-input"
         placeholder="0.00"
         [value]="getDisplayValue()"
         [required]="required"
         [ngClass]="{
        'has-tooltip': toolTipMessage,
        'is-invalid': control.invalid && (control.dirty || control.touched),
        'is-valid': (required ? (control.valid && (control.dirty || control.touched) && control.value !== '') : (control.valid && control.value !== '' && (control.dirty || control.touched))),
        'custom-valid': (required ? (control.valid && control.value !== '') : (control.valid && control.value !== '')),
        'ng-invalid': control.invalid
      }"
         (input)="onInputChange($event)"
         [min]="min"
         [max]="max"
         [readonly]="readonly">

  <label *ngIf="label" for="currency-{{htmlId}}">
    {{ label }}
  </label>
  <span class="input-group-text currency-symbol-wrap" [ngClass]="{'border-success' : !error && control.touched && (required ? (control.valid && control.value) : control.value)}">
      <span class="currency-symbol">{{ getCurrencySymbol() }}</span>
  </span>

  <ng-container *ngIf="error">
    <div class="error-message text-warning ps-2">
      {{ 'General.ErrorCheckInput' | translate }}
    </div>
  </ng-container>
</div>
